/**
 * lib/proveedorTheme.js -- Port de proveedor-theme.js. Deliberadamente
 * separado de theme/theme.js: ese modulo resuelve el sistema de marcas
 * INTERNO que este portal jamas debe cargar -- ver cabecera de
 * proveedor-auth.css. Efecto de lado en el DOM (atributo data-theme), no
 * hay nada que "reactificar" aqui: corre UNA vez al boot, antes de que
 * exista sesion.
 *
 * Solo se usa `brand` de la respuesta: proveedor-tokens.css deriva toda la
 * paleta (botones, foco, superficies, sombras) de data-theme, y
 * brand-logo.css el logo. El `color` hex que tambien manda el backend ya
 * no hace falta en este portal.
 */
import { api } from './api.js';

/* Mismo default que el backend (DEFAULT_PROVEEDOR_BRAND en themeService.ts)
 * y que el :root de proveedor-tokens.css. */
const FALLBACK_BRAND = 'mr';
const BRANDS = ['w2', 'b3', 'rs', 'mr', 'or'];

export function proveedorScheme(theme) {
  return /^(W2|B3|RS|MR|OR)D$/i.test(theme || '') ? 'dark' : 'light';
}

export function applyProveedorScheme(theme) {
  document.documentElement.setAttribute('data-color-scheme', proveedorScheme(theme));
}

/** El color guardado en la preferencia nunca reemplaza al administrado. */
export function buildProveedorTheme(scheme) {
  const brand = document.documentElement.getAttribute('data-theme');
  return `${BRANDS.includes(brand) ? brand : FALLBACK_BRAND}${scheme === 'dark' ? 'd' : ''}`.toUpperCase();
}

export async function applyProveedorTheme() {
  let brand = FALLBACK_BRAND;
  try {
    const res = await api.getProveedorTheme();
    if (res.ok && BRANDS.includes(res.brand)) brand = res.brand;
  } catch {
    // Sin red: se queda el default, para que paleta y logo coincidan
    // (el :root de brand-logo.css es otro color).
  }
  document.documentElement.setAttribute('data-theme', brand);
  applyProveedorScheme('MR');
}
